import { ComponentProps, ForwardedRef, forwardRef } from "react"
import { Close, Document, FileUpload } from "../../../../../images/xd/icons"
import { SFileInput, SFileInputWrapper, SRightContentWrapper } from "../../acquisitionForm/AcquisitionForm.styled"
import Text from "../../../../../components/Text"
import { styled, theme } from "../../../../../styles/stitches.config"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { FormError } from "./Form"
import { Div } from "../../../../../components/div/Div"
import { Span } from "../../../../../components/span/Span"
import { MAX_FILE_SIZE_MB } from "../utils"
import { InputDisclaimer } from "./Input"

const UploadButton = styled("div", {
  display: "flex",

  alignItems: "center",
  justifyContent: "center",

  height: theme.sizes.s12_5,
  width: "100%",
  backgroundColor: theme.colors.secondary,
  color: theme.colors.primary,
  textTransform: "uppercase",

  "@sm": {
    width: "45%",
  },
})

type Props = {
  id: string
  error?: string
  uploadedFileName?: string
  onClear?: () => void
  onChange?: ComponentProps<"input">["onChange"]
  onBlur?: ComponentProps<"input">["onBlur"]
}

function FileInputRaw(props: Props, ref: ForwardedRef<HTMLInputElement>) {
  const { id, error, uploadedFileName, onClear, onChange, onBlur } = props
  const Icon = uploadedFileName ? Document : FileUpload

  return (
    <Div>
      <Spacer size={theme.space.s3_5} />
      <SFileInputWrapper htmlFor={id}>
        <SFileInput state={error ? "error" : uploadedFileName ? "success" : "default"}>
          <Icon width={24} height={24} style={{ flexShrink: 0 }} />
          {uploadedFileName ? uploadedFileName : "Soubor přetáhněte nebo nahrajte"}
          {uploadedFileName && (
            <SRightContentWrapper>
              <Close
                color={theme.colors.errors.value}
                width={28}
                height={28}
                onClick={(e) => {
                  e.preventDefault()
                  onClear?.()
                }}
              />
            </SRightContentWrapper>
          )}
        </SFileInput>
        <UploadButton>
          <Text
            type="headerH3"
            css={{
              fontSize: theme.sizes.s3_5,
            }}
          >
            Nahrát
          </Text>
        </UploadButton>
      </SFileInputWrapper>
      <input
        id={id}
        type="file"
        accept="application/pdf, image/*"
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        style={{ display: "none" }}
      />

      {error && (
        <>
          <Spacer size={theme.space.s1_5} />
          <FormError
            css={{
              paddingRight: "30%",
              fontSize: theme.sizes.s2_5,
            }}
          >
            {error}
          </FormError>
        </>
      )}
    </Div>
  )
}

export const FileInput = forwardRef(FileInputRaw)
export function FileInputDisclaimer() {
  return (
    <InputDisclaimer
      label={
        <p>
          Nahrajte soubor <Span css={{ fontWeight: theme.fontWeights.semiBold }}>PDF nebo obrázek</Span> o maximální
          velikosti <Span css={{ fontWeight: theme.fontWeights.semiBold }}>{MAX_FILE_SIZE_MB} MB</Span>.
        </p>
      }
    />
  )
}
